// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":not(.v-icon){font-family:\"Hiragino Sans\"!important}", ""]);
// Exports
module.exports = exports;
